import React, { useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import SbuxTranslate from "../SbuxTranslate";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import { useAppDispatch } from "../../store/types";
import { StyledFiltersButton } from "./styled";

interface FilterSubItem {
  key: string;
  value: string;
}

interface FilterColumn {
  id?: string | number;
  key?: string;
  value?: string;
  subTitle?: string;
  filterList?: FilterSubItem[];
  [key: string]: unknown;
}

interface Props {
  columns: FilterColumn[];
  title?: React.ReactNode;
  defaultFilterColumns?: string[];
  setFilteredItem: (
    items: string[],
  ) => void | { type: string; [key: string]: unknown };
}

const SbuxTableFilters = ({
  columns,
  title,
  defaultFilterColumns = [],
  setFilteredItem,
}: Props) => {
  let columnNameArray: string[] = [];
  const defaultFiler =
    defaultFilterColumns && defaultFilterColumns.length > 0
      ? defaultFilterColumns
      : [];

  const [open, setOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(true);
  const [seletedItem, setSeltectedItem] = useState<string[]>(defaultFiler);
  const dispatch = useAppDispatch();

  const handleModal = () => {
    setOpen(!open);
  };

  const handleToggle = async (event: React.ChangeEvent<{}>, value: string) => {
    const currentIndex = seletedItem.indexOf(value);
    let newChecked = [...seletedItem];
    if (
      value === "all" &&
      (event as React.ChangeEvent<HTMLInputElement>).target.checked
    ) {
      newChecked = [...columnNameArray];
    } else if (
      value === "all" &&
      !(event as React.ChangeEvent<HTMLInputElement>).target.checked
    ) {
      newChecked = [];
    } else if (currentIndex === -1) {
      newChecked.push(value);
      newChecked.sort();
      const isMatchedData = columnNameArray
        .filter((f) => f !== "all")
        .sort()
        .every((element, index) => element === newChecked[index]);

      if (isMatchedData) newChecked.push("all");
      else newChecked = newChecked.filter((f) => f !== "all");
    } else {
      Array.isArray(newChecked) && newChecked.splice(currentIndex, 1);
      const indexOfAllText = newChecked.indexOf("all");
      if (indexOfAllText >= 0) {
        newChecked.splice(indexOfAllText, 1);
      }
    }

    await setSeltectedItem(newChecked);
    const filterAction = setFilteredItem(newChecked);
    if (filterAction !== undefined) {
      await dispatch(filterAction as { type: string; payload?: unknown });
    }
    setIsFiltered(true);
  };

  const getFormLabel = (display: string, value: string) => {
    columnNameArray.push(value);
    const key = `${display}-${value}`;
    return (
      <FormControlLabel
        key={key}
        sx={{ padding: "10px" }}
        onChange={(e) => handleToggle(e, value)}
        control={
          <Checkbox
            checked={seletedItem.indexOf(value) !== -1}
            disableRipple
            tabIndex={-1}
          />
        }
        label={
          <span style={{ fontSize: 14 }}>
            <SbuxTranslate>{display}</SbuxTranslate>
          </span>
        }
      />
    );
  };

  const list = () => (
    <Box role="presentation" onKeyDown={handleModal}>
      <List>
        <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }}>
          <ListItemText sx={{ textAlign: "center" }}>
            <span style={{ fontSize: 18 }}>{title}</span>
          </ListItemText>
        </ListItem>
      </List>
      <Divider />
      <List>
        {columns.map((column) => (
          <ListItem
            key={column.id}
            sx={{ width: 200, paddingBottom: 0, paddingTop: 0 }}
          >
            {column.subTitle ? (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
              >
                <span
                  style={{ fontSize: 16, fontWeight: 600, textAlign: "left" }}
                >
                  <SbuxTranslate>{column.subTitle}</SbuxTranslate>
                </span>
                <Divider />
                {(column.filterList ?? []).map((subColumn) =>
                  getFormLabel(subColumn.key, subColumn.value),
                )}
              </Box>
            ) : (
              getFormLabel(
                String(column.label ?? column.key ?? column.id ?? ""),
                String(column.value ?? column.id ?? ""),
              )
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box display="flex" alignItems="center">
      <StyledFiltersButton
        isFiltered={
          isFiltered && seletedItem.length > 0 && seletedItem.includes("all")
        }
        onClick={handleModal}
      />
      <div id="container-table">
        <Box sx={{ overflow: "hidden", flex: 1 }}>
          <Drawer
            anchor={"right"}
            open={open}
            PaperProps={{
              sx: {
                position: "absolute",
              },
            }}
            ModalProps={{
              container: document.getElementById("container-table"),
              disableEnforceFocus: true,
              onClose: handleModal,
              sx: {
                position: "absolute",
                overflow: "hidden",
                height: "67.5vh",
                marginTop: 7.5,
                marginRight: 2,
                marginBottom: 2,
              },
            }}
            variant="temporary"
          >
            {list()}
          </Drawer>
        </Box>
      </div>
    </Box>
  );
};

export default SbuxTableFilters;
